export default __webpack_public_path__ + "static/media/truck-00.c8890721.jpg";